<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import authService from "../services/auth.service.js";

export default {
  name: "OidcAuth",
  setup() {
    const router = useRouter();

    onMounted(async () => {
      const returnUrl = router.currentRoute.value.query.returnUrl || "";
      await authService.logout(true, returnUrl);

      if (returnUrl != "") {
        router.push(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
      } else {
        router.push("/login");
      }
    });

    return {
      router,
    };
  },
};
</script>
